export default __webpack_public_path__ + "static/media/Салбар_уулзалт_төсвийн_санхүүжилт,_хувьсах_зардлын_бүрэлдэхүүн.6c05d240.pdf";